import { render, staticRenderFns } from "./ExamCreate.vue?vue&type=template&id=47ac1fe1&scoped=true&"
import script from "./ExamCreate.vue?vue&type=script&lang=js&"
export * from "./ExamCreate.vue?vue&type=script&lang=js&"
import style0 from "./ExamCreate.vue?vue&type=style&index=0&id=47ac1fe1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac1fe1",
  null
  
)

export default component.exports